import { render, staticRenderFns } from "./my-contact-details.vue?vue&type=template&id=5b843a15&scoped=true"
import script from "./my-contact-details.vue?vue&type=script&lang=js"
export * from "./my-contact-details.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b843a15",
  null
  
)

export default component.exports